var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNews2 = function SvgNews2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 6C34 6 36 7.9 36 10.2v15.4c0 2.4-1.9 4.2-4.2 4.2h-2V32a4 4 0 0 1-3.7 4H11.8A5.8 5.8 0 0 1 6 30.5V16.2a4 4 0 0 1 3.8-4h2.4v-2C12.2 8 14 6 16.4 6h15.4Zm-19.6 8.5H10c-.9 0-1.6.6-1.7 1.5v14.2c0 1.9 1.4 3.4 3.3 3.5h14.2c1 0 1.6-.7 1.7-1.5v-2.4H16.4a4.2 4.2 0 0 1-4.2-4.2V14.5Zm19.6-6.2H16.4c-1 0-2 .9-2 2v15.3c0 1 1 2 2 2h15.4c1 0 1.9-1 1.9-2V10.2c0-1-.9-1.9-2-1.9h.1Zm-3.9 11.5a1.2 1.2 0 0 1 .2 2.3h-7.9a1.2 1.2 0 0 1-.1-2.2h7.8v-.1Zm-8.2-6.3h7.6c.7 0 1.2.6 1.2 1.3 0 .6-.5 1.2-1.2 1.2h-7.6c-.7 0-1.2-.6-1.2-1.3 0-.6.5-1.2 1.2-1.2Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNews2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news2.100249bb2f361ee7ca17afab1f258731.svg";